export default [
  {
    path: "/report-uploader/:type/upload",
    name: "report-uploader-page",
    component: () => import("@/views/ReportUploader/ReportUploaderInfo.vue"),
    meta: {
      title: "Upload Report",
      ability: { action: "create", subject: "DailyReportUploader" },
    },
  },
];

export const reportUploaderMenu = [
  {
    path: "/report-uploader",
    name: "report-uploader",
    icon: "pie-chart",
    component: () => import("@/views/ReportUploader/ReportUploaderList.vue"),
    meta: {
      title: "Report Uploader",
      ability: { action: "read", subject: "DailyReportUploader" },
    },
  },
];
